export default __webpack_public_path__ + "2cf00c4.png";